<div class="subscription-plans-container">
  <div class="subscription-plans-wrapper">
    <div class="pricing-card quarterly-plan shadow">
      <div class="pricing-content">
        <div class="pricing-header">
          <span class="plan-title has-text-weight-bold">
            <span>{{ "SUBSCRIPTION_PLANS.QUARTERLY.TITLE"|translate }}</span>
          </span>
          <div class="price-section">
            <div class="price-display">
              <span class="price-amount"><span>€29.00</span></span>
              <span class="price-period has-text-weight-bold">
                <span>/ {{ "SUBSCRIPTION_PLANS.QUARTERLY.SUBTITLE"|translate }}</span>
              </span>
            </div>
            <span class="price-description Smallertext14|Regular">
              <span>{{ "SUBSCRIPTION_PLANS.QUARTERLY.DESCRIPTION"|translate }}</span>
            </span>
          </div>
        </div>
        <img src="/line320i654-bknn.svg" alt="Line320I654" class="divider-line" />
        <div class="features-section">
          <div class="features-content">
            <span class="features-header has-text-weight-bold has-text-centered">
              <span>{{ "SUBSCRIPTION_PLANS.FEATURES.LIST_HEADER"|translate }}</span>
            </span>
            <div class="features-list">
              <div class="feature-item">
                <img src="/assets/img/chevron-down-solid.svg" class="feature-icon" />
                <span class="feature-text Caption12|Regular">
                  <span>{{ "SUBSCRIPTION_PLANS.FEATURES.LIST_ITEM_1"|translate }}</span>
                </span>
              </div>
              <div class="feature-item">
                <img src="/assets/img/chevron-down-solid.svg" alt="checked144I654" class="feature-icon" />
                <span class="feature-text Caption12|Regular">
                  <span>{{ "SUBSCRIPTION_PLANS.FEATURES.LIST_ITEM_2"|translate }}</span>
                </span>
              </div>
              <div class="feature-item">
                <img src="/assets/img/chevron-down-solid.svg" alt="checked144I654" class="feature-icon" />
                <span class="feature-text Caption12|Regular">
                  <span>{{ "SUBSCRIPTION_PLANS.FEATURES.LIST_ITEM_3"|translate }}</span>
                </span>
              </div>
              <div class="feature-item">
                <img src="/assets/img/chevron-down-solid.svg" alt="checked144I654" class="feature-icon" />
                <span class="feature-text Caption12|Regular">
                  <span>{{ "SUBSCRIPTION_PLANS.FEATURES.LIST_ITEM_4"|translate }}</span>
                </span>
              </div>
            </div>
            <span class="billing-info has-text-weight-bold has-text-centered">
              <span>{{ "SUBSCRIPTION_PLANS.FEATURES.LIST_ITEM_MONTHLY"|translate }}</span>
            </span>
          </div>
          <button class="subscribe-btn quarterly-btn" (click)="subscribeQuarterly()" [disabled]="disableButtons()">
            <div class="btn-content">
              <span class="btn-text has-text-weight-bold">
                <span>{{ "MOBILE.SUBSCRIPTION.SUBSCRIBE"|translate }}</span>
              </span>
            </div>
          </button>
          @if (!isProduction) {
          <button class="subscribe-btn odoo-btn" (click)="subscribeQuarterlyUsingOdoo()" [disabled]="disableButtons()">
            <div class="btn-content">
              <span class="btn-text has-text-weight-bold">
                <span>{{ "SUBSCRIPTION_PLANS.ODOO.BUTTON"|translate }}</span>
              </span>
            </div>
          </button>
          }
        </div>
      </div>
    </div>
    <div class="pricing-card annual-plan shadow">
      <div class="pricing-content">
        <div class="pricing-header">
          <span class="plan-title has-text-weight-bold">
            <span>{{ "SUBSCRIPTION_PLANS.ANNUAL.TITLE"|translate }}</span>
          </span>
          <div class="price-section">
            <div class="price-display">
              <span class="price-amount annual-price"><span>€99.00</span></span>
              <span class="price-period has-text-weight-bold">
                <span>/ {{ "SUBSCRIPTION_PLANS.ANNUAL.SUBTITLE"|translate }}</span>
              </span>
            </div>
            <span class="price-description Smallertext14|Regular">
              <span>{{ "SUBSCRIPTION_PLANS.ANNUAL.DESCRIPTION"|translate }}</span>
            </span>
          </div>
        </div>

        <img src="/line320i654-lh1f.svg" alt="Line320I654" class="divider-line" />
        <div class="features-section">
          <div class="features-content">
            <span class="features-header has-text-weight-bold has-text-centered">
              <span>{{ "SUBSCRIPTION_PLANS.FEATURES.LIST_HEADER"|translate }}</span>
            </span>
            <div class="features-list">
              <div class="feature-item">
                <img src="/assets/img/chevron-down-solid.svg" alt="checked144I654" class="feature-icon" />
                <span class="feature-text Caption12|Regular">
                  <span>{{ "SUBSCRIPTION_PLANS.FEATURES.LIST_ITEM_1"|translate }}</span>
                </span>
              </div>
              <div class="feature-item">
                <img src="/assets/img/chevron-down-solid.svg" alt="checked144I654" class="feature-icon" />
                <span class="feature-text Caption12|Regular">
                  <span>{{ "SUBSCRIPTION_PLANS.FEATURES.LIST_ITEM_2"|translate }}</span>
                </span>
              </div>
              <div class="feature-item">
                <img src="/assets/img/chevron-down-solid.svg" alt="checked144I654" class="feature-icon" />
                <span class="feature-text Caption12|Regular">
                  <span>{{ "SUBSCRIPTION_PLANS.FEATURES.LIST_ITEM_3"|translate }}</span>
                </span>
              </div>
              <div class="feature-item">
                <img src="/assets/img/chevron-down-solid.svg" alt="checked144I654" class="feature-icon" />
                <span class="feature-text Caption12|Regular">
                  <span>{{ "SUBSCRIPTION_PLANS.FEATURES.LIST_ITEM_4"|translate }}</span>
                </span>
              </div>
            </div>
            <span class="billing-info has-text-weight-bold has-text-centered">
              <span
                >{{(resubscription()?"SUBSCRIPTION_PLANS.FEATURES.LIST_ITEM_MONTHLY":
                "SUBSCRIPTION_PLANS.FEATURES.LIST_ITEM_ANNUAL")|translate }}</span
              >
            </span>
          </div>
          <button class="subscribe-btn annual-btn" (click)="subscribeYearly()" [disabled]="disableButtons()">
            <div class="btn-content">
              <span class="btn-text has-text-weight-bold">
                <span
                  >{{ (resubscription()? "MOBILE.SUBSCRIPTION.SUBSCRIBE":"SUBSCRIPTION_PLANS.ANNUAL.BUTTON")|translate
                  }}</span
                >
              </span>
            </div>
          </button>
          @if (!isProduction) {
          <button class="subscribe-btn odoo-btn" (click)="subscribeAnnuallyUsingOdoo()" [disabled]="disableButtons()">
            <div class="btn-content">
              <span class="btn-text has-text-weight-bold">
                <span>{{ "SUBSCRIPTION_PLANS.ODOO.BUTTON"|translate }}</span>
              </span>
            </div>
          </button>
          }
        </div>
      </div>
    </div>
  </div>
</div>
